import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const faqs = [{
  q: '¿Dónde están ubicados?',
  a: 'Estamos en Costa Rica. Consultá por WhatsApp la zona de entrega o retiro disponible.'
}, {
  q: '¿Hacen entregas o retiro?',
  a: 'Coordinamos según disponibilidad y zona. Escribinos por WhatsApp para confirmar.'
}, {
  q: '¿Con cuánta anticipación debo pedir?',
  a: 'Recomendamos consultar con anticipación porque la producción puede estar sujeta a disponibilidad.'
}, {
  q: '¿Tienen pedidos para reuniones?',
  a: 'Sí. Podés consultar opciones para reuniones, cumpleaños, oficina o eventos pequeños.'
}, {
  q: '¿Cuáles son los métodos de pago?',
  a: '[Completar métodos reales: SINPE, efectivo, transferencia u otros.]'
}, {
  q: '¿El menú siempre es el mismo?',
  a: 'El menú puede variar según producción. Consultá los sabores disponibles por WhatsApp.'
}];
export function Faq() {
  return <section id="faq" className="w-full scroll-mt-24 bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-35" data-mp="pizd5qpiisco">
      <div className="mx-auto w-full max-w-3xl" data-id="element-36" data-mp="ufpu0g955rz5">
        <SectionHeading title="Preguntas frecuentes" data-id="element-37" data-mp="fjrzt3is2xpk" />

        <div className="mt-10 space-y-3" data-id="element-38" data-mp="fj8inp0ycdcl">
          {faqs.map(({
          q,
          a
        }) => <details key={q} className="group rounded-2xl border border-aqua-200 bg-white px-5 py-4 [&_summary::-webkit-details-marker]:hidden" data-id="element-39" data-mp="khtk1rrxx32m">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-[14.5px] font-semibold text-night-900" data-id="element-40" data-mp="bieuqvnieyjp">
                {q}
                <ChevronDownIcon className="h-4 w-4 shrink-0 text-aqua-600 transition-transform duration-200 group-open:rotate-180" aria-hidden="true" data-id="element-41" data-mp="3swtqavo3t6ws" />
              </summary>
              <p className="mt-3 text-[13.5px] leading-relaxed text-muted" data-id="element-42" data-mp="3o03a88caubbd">{a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}